import { gridSize, gridSizeMdLg4, TipoProductoEnumChoice, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchCategoryProduct, useFetchProductoSimple } from "@/shared/actions/erp";
import { CustomAutocomplete, CustomTextFieldNoForm, GeneralTable, SearchComponente, TabTextLabel } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { AlertSeverityEnum, IDataProducto } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { Add } from "@mui/icons-material";
import { Button, Grid, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useTableProductos from "../../pages/detallesPedidosTableDynamic/usedetallesProductosTable";
import { CATEGORYPRODUCT } from "@/shared/interfaces/erp/inventario";

type ModalProductoEgresoComponete = {
  onChange: (e: IDataProducto) => void,
  ubicacion: string,
}

export default function ModalProductoEgresoComponete({ onChange, ubicacion }: ModalProductoEgresoComponete) {
  //*store
  const setAlert = useUiStore(s => s.setAlert)
  ///state
  const [isOpenModal, setIsModalOpen] = useState(false)
  const [selectedCategoria, setSelectedCategoria] = useState<string>('')
  //form
  const form = useForm()
  const { control } = form
  //*hook
  const { columnsProductos } = useTableProductos()
  const {
    pagination,
    setPagination,
    globalFilter,
    onChangeFilter,
    searchTerm,
    cleanFilter
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering()
  //**FETCH */
  const { data: dataProducto, isLoading: isLoadingProducto,
    isRefetching: isRefetchingProducto
    /* } = useFetchProductos({ */
  } = useFetchProductoSimple({
    params: {
      page_size: pageSize,
      page: pageIndex + 1,
      tipo_producto: TipoProductoEnumChoice.INVENTARIABLE,
      estado:true,
      //es_activo:true,
      //categoria_producto: selectedCategoria,
      descripcion: searchTerm.toUpperCase(),
      ...filterObject,
      filterByState: false,
      ...(selectedCategoria ? { categoria_producto: selectedCategoria } : {})
    }
  })

  const {
    data: dataCatergoria,
    isLoading: isLoadingcategoria
  } = useFetchCategoryProduct({
    page_size: 600
  })
  //** */
  const opcionTodos = { codigo: "", nombre: "- TODOS -" }
  const categorias = dataCatergoria?.data?.data || []
  const opcionesCategoria = [opcionTodos, ...categorias]
  //* 
  const handleCategoriaProducto = (e: string) => {
    setSelectedCategoria(e)
  }

  const onChangeAux = (item: IDataProducto) => {
    onChange(item)
  }
  ///us
  useEffect(() => {
    if (!isOpenModal) {
      form.setValue('categoria_producto', '')
      setSelectedCategoria('')
      cleanFilter() /// limpia la paginacion
    }

  }, [isOpenModal])
  //*
  return (
    <>
      <Button
        variant="outlined"
        startIcon={<Add />}
        onClick={() => {
          if (!ubicacion) {
            setAlert(true, 'Seleccionar una ubicacion para la solicitud.', AlertSeverityEnum.info)
            return;
          }
          setIsModalOpen(true)
        }}
      >
        Agregar Items
      </Button>

      <ScrollableDialogProps
        open={isOpenModal}
        title="Productos"
        onCloseIcon={() => setIsModalOpen(false)}
        minWidth="70%"
        contentNode={
          <>
            <Grid item {...gridSize}>
              <Paper className="paper-producto">
                <Grid container spacing={2} alignItems={'center'}>
                  <Grid item {...gridSizeMdLg4}>
                    <SearchComponente
                      value={globalFilter}
                      text="por descripcion"
                      onChange={onChangeFilter}
                    />
                  </Grid>

                  <Grid item {...gridSizeMdLg4}>
                    <CustomTextFieldNoForm
                      disabled={true}
                      label="Tipo producto"
                      defaultValue={TipoProductoEnumChoice.INVENTARIABLE}
                    />
                  </Grid>
                  <Grid item {...gridSizeMdLg4}>
                    <CustomAutocomplete<CATEGORYPRODUCT | { nombre: string, codigo: string }>
                      label="Categoria del producto"
                      name="categoria_producto"
                      options={opcionesCategoria}
                      //options={dataCatergoria?.data.data || []}
                      valueKey="nombre"
                      actualValueKey="codigo"
                      defaultValue={''}
                      isLoadingData={isLoadingcategoria}
                      control={control}
                      error={undefined}
                      helperText={undefined}
                      onChangeValue={(e) => { handleCategoriaProducto(e) }}

                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TabTextLabel text="Agregar Producto" mt={0} pb={0} pl={0} pt={0} />
                  </Grid>
                  <div className="linea"></div>
                  {/* selectedCategoria && ( */
                    <GeneralTable<IDataProducto>
                      columns={columnsProductos}
                      data={dataProducto?.data.data || []}
                      //
                      enableGlobalFilter={false}
                      isLoading={isLoadingProducto}
                      isRefetching={isRefetchingProducto}
                      //
                      pagination={pagination}
                      onPaging={setPagination}
                      rowCount={dataProducto?.data.count}
                      /// filter for column
                      columnFilters={columnFilters}
                      onColumnFiltersChange={setColumnFilters}
                      enableManualFiltering={true}
                      enableSorting={false}
                      ///
                      canEdit={false}
                      canAdd={true}
                      onAdd={(e) => { onChangeAux(e) }}
                    />
                  /* ) */}

                </Grid>

              </Paper>
            </Grid>
          </>
        }

      />

    </>
  )
}